/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatClientPersonaUpdateRequest
 */
export interface ChatClientPersonaUpdateRequest {
    /**
     * Updated display name of the chat client
     * @type {string}
     * @memberof ChatClientPersonaUpdateRequest
     */
    name: string;
    /**
     * Updated email address of the chat client
     * @type {string}
     * @memberof ChatClientPersonaUpdateRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ChatClientPersonaUpdateRequest interface.
 */
export function instanceOfChatClientPersonaUpdateRequest(value: object): value is ChatClientPersonaUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ChatClientPersonaUpdateRequestFromJSON(json: any): ChatClientPersonaUpdateRequest {
    return ChatClientPersonaUpdateRequestFromJSONTyped(json, false);
}

export function ChatClientPersonaUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatClientPersonaUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
    };
}

export function ChatClientPersonaUpdateRequestToJSON(json: any): ChatClientPersonaUpdateRequest {
    return ChatClientPersonaUpdateRequestToJSONTyped(json, false);
}

export function ChatClientPersonaUpdateRequestToJSONTyped(value?: ChatClientPersonaUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
    };
}

